import { render } from "./viewdata.vue?vue&type=template&id=75440540"
import script from "./viewdata.vue?vue&type=script&lang=js"
export * from "./viewdata.vue?vue&type=script&lang=js"

import "./viewdata.vue?vue&type=style&index=0&id=75440540&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__